import { useLocation } from "react-router-dom"

import { AfterFooter } from "components"
import { NextPageButtonWithAdditionalInfo } from "modules/Booking/SessionDatePage/components/NextPageButtonWithAdditionalInfo"
import style from "modules/Booking/SessionDatePage/components/NextPageButtonWithAdditionalInfoWithFooterMobile/style.module.scss"

export function NextPageButtonWithAdditionalInfoWithFooterMobile() {
    const { key } = useLocation()

    return (
        <AfterFooter afterFooterKey={key}>
            <div className={style.container}>
                <NextPageButtonWithAdditionalInfo regimen="mobile" />
            </div>
        </AfterFooter>
    )
}
